export const itineraryInitialValues = {
  cdLinhaItinerario: '',
  cdLinha: '',
  cdLinhaSituacao: '',
  cdTipoItinerario: '',
  cdRevisao: '',
  dtCadastro: new Date(),
  deObservacao: '',
  linha: {},
  tipoItinerario: {},
  situacao: {},
  localidades: [],
};